<template>
    <div class="klgItem" @click="$router.push(`/emrClass/knowledgeDetail?id=${encodeURIComponent(id)}`)">
        <img src="../../assets/point.svg"> 
        <span class="title">{{Title}}</span>
        <span class="date">{{AdminSetTime}}</span>
    </div>
</template>
<script>
export default {
    name:'klgItem',
    props:{
        Title:String,
        AdminSetTime:String,
        id:String
    }
}
</script>
<style lang="scss" scoped>
.klgItem{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 24px;
    cursor: pointer;
    img{
        margin-right: 10px;
    }
    .title{
        @include hideTextOverflow;
        flex:1;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>


